var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeClosed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.88842 8.44744L1.15136 9.28884C1.45101 10.2477 1.86617 11.1466 2.37864 11.972L0.249901 13.201L1.7499 15.7991L4.30479 14.324C4.78987 14.7798 5.31273 15.1933 5.86726 15.56L4.70091 17.5802L7.29899 19.0802L8.56759 16.8829C9.19199 17.0944 9.83804 17.2542 10.5 17.3582V20H13.5V17.4407C14.3443 17.3556 15.1664 17.1798 15.9549 16.9221L17.2009 19.0802L19.799 17.5802L18.6711 15.6266C19.2182 15.273 19.7352 14.8742 20.2164 14.4344L22.5801 15.7991L24.0801 13.201L22.1789 12.1033C22.7295 11.2422 23.1733 10.2988 23.4889 9.28884L23.7519 8.44744L20.8884 7.55261L20.6255 8.39401C19.4903 12.0266 16.126 14.5 12.3201 14.5C8.51427 14.5 5.15 12.0266 4.0148 8.39402L3.75186 7.55261L0.88842 8.44744Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeClosed);
export default __webpack_public_path__ + "static/media/eye-closed.820cc9136993b479efd4c8d83302d702.svg";
export { ForwardRef as ReactComponent };